module.exports = __webpack_public_path__ + "static/media/claro-club.863556d8.svg";